import React from 'react';

import Logout from '../Components/Buttons/Logout';
import Hamburger from '../Components/Buttons/Hamburger';

import style from '../../../scss/layouts/header.module.scss';
import GlowAndKnowLogo from '../Components/Svg/GlowAndKnowLogo';
import {useTranslation} from "react-i18next";
import Logo from "../Components/Svg/Logo";

const Header = ({ ...props }) => {
    const { i18n } = useTranslation();
    const isHu = i18n.language === 'hu';
    return (
        <header className={style.header}>
            <div className={style.wrapper}>
                <Hamburger {...props} />
                {isHu ? <Logo /> : <GlowAndKnowLogo />}
                <Logout />
            </div>
        </header>
    );
};

export default Header;
